import AuthImage from "@assets/image/auth_image.png";
const AuthLayout = () => {
  return (
    <div className="relative hidden h-56 sm:h-80 md:block md:h-auto md:w-1/2">
      <img src={AuthImage} alt="Goodweeks" className="absolute inset-0 size-full " />
      <div className="absolute left-[12%] top-[9%] ">
        <img src="/goodweek_auth.svg" alt="Goodweeks Logo" width={160} height={50} />
      </div>
      <h1 className="absolute left-[12%] top-[18%] text-2xl font-bold text-white">
        Start your journey by <br /> one click, explore <br />
        beautiful world!
      </h1>
    </div>
  );
};

export default AuthLayout;
